import { FormCommentPanel } from 'pages/FormProcess/components';
import { useManageFormComments } from '../../../FieldRenderer/FormComments/hooks/useManageFormComments';

export const CommentBadgePanel = ({ isOpen, setOpen }) => {
  const { commentUsers, commentActions, formsComments } = useManageFormComments();

  return (
    <FormCommentPanel
      commentPanelOpen={isOpen}
      setCommentPanelOpen={setOpen}
      threads={
        Object.values(formsComments)
          .flat()
          .filter(({ Comments }) => Comments.length) as any[]
      }
      commentUsers={commentUsers}
      {...commentActions}
      dynamicComment
    />
  );
};
